module.exports = __webpack_public_path__ + "fonts/Merriweather-500-cyrillic18.655c184.woff2";